import { parsePhoneNumberFromString } from "libphonenumber-js/max";
/** No extraction, extensions or implicit foreign-country guessing. Local numbers mean Lebanon. */
export function normalizePhone(value: string): string | null {
  const input = value.trim();
  if (!input) return "";
  if (input.length > 40 || !/^\+?[\d\s()./-]+$/.test(input)) return null;
  const digits = input.replace(/\D/g, "");
  // Bare international or IDD numbers are ambiguous; require an explicit +.
  if (!input.startsWith("+") && (digits.length > 8 || digits.startsWith("00")))
    return null;
  const parsed = parsePhoneNumberFromString(input, {
    defaultCountry: "LB",
    extract: false,
  });
  if (
    !parsed ||
    parsed.ext ||
    !parsed.isValid() ||
    (!input.startsWith("+") && parsed.country !== "LB")
  )
    return null;
  return parsed.number;
}
export function whatsappUrl(value: string) {
  const phone = normalizePhone(value);
  return phone ? "https://wa.me/" + phone.slice(1) : null;
}
